export enum Environment {
	DEV = "DEV",
	STAGING = "STAGING",
	PRODUCTION = "PRODUCTION",
}

export const PROJECT_NAME = process.env.NEXT_PUBLIC_PROJECT_NAME;
export const NAVBAR_NAME = process.env.NEXT_PUBLIC_NAVBAR_NAME;
export const SITE_NAME = process.env.NEXT_PUBLIC_SITE_NAME;
export const WEB_LINK = process.env.NEXT_PUBLIC_WEB_LINK;
export const API_LINK = process.env.NEXT_PUBLIC_API_LINK;
export const BASE_URL_PLACEHOLDER = "{{BASE_URL}}";
export const ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT;

/**
 * Cloudflare Turnstile site key for the login page (public by design — the
 * secret half lives in mlm-server as TURNSTILE_SECRET_KEY). EMPTY = the login
 * page renders no captcha, which is also what the server does when its own key
 * is unset: both halves are switched on together, per environment.
 */
export const TURNSTILE_SITE_KEY =
	process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || "";
export const isTurnstileEnabled = TURNSTILE_SITE_KEY.length > 0;

export const isProduction = ENVIRONMENT === "PRODUCTION";

export const CONFIG_1_PROJECTS = ["pghard", "pgpro"];
export const CONFIG_2_PROJECTS = ["tripleclick"];

export const isConfig1Project = CONFIG_1_PROJECTS.includes(PROJECT_NAME || "");
export const isConfig2Project = CONFIG_2_PROJECTS.includes(PROJECT_NAME || "");

// The brand vocabulary (TOTAL_AMOUNT, CREDIT_QUOTA, QUOTA_DEDUCTION_RATE, ...)
// is translated now: useTerms() in src/i18n/use-terms.ts.
